import React, { ReactNode, useEffect, useState } from 'react'
import { View } from 'styles/reactnative'
import { AdminTableHeaderSection } from './styles'
import { AdminCModal } from '../Common'

import AdminSearch from '../AdminSearch'
import { useAllMembers } from '../../hooks/adminUsers/members'
import AdminSubTitle from '../AdminSubTitle'
import AdminUserCreate from '../AdminUserCreate'
import { Addbutton } from '../Buttons'
import { Select, Space, Switch } from 'antd'
import { useFetcher } from '../../hooks/fetcher'
import { useToken } from '../../hooks'
import { useUserGroup } from '../../hooks/user/usergroups'
type AdminTableHeaderProps = {
	title?: string
	type?: string
	search?: boolean
	CustomComp?: ReactNode
	group?: string
	setGroup?: any
}

const AdminTableHeader = ({
	title = '',
	type = '',
	search = true,
	CustomComp = null,
	group = '*',
	setGroup = () => {},
}: AdminTableHeaderProps) => {
	const [showModal, setShowModal] = useState(false)
	const {
		searchWords,
		searchType,
		searchWord,
		haswallet,
		exceptType,
		setHaswallet,
		setOrderType,
		orderSort,
		setExceptType,
	} = useAllMembers()
	const { data: token } = useToken()

	const { type1 } = useUserGroup()

	const [order, setOrder] = useState<any>('DESC')
	const [orderType, setOrderType1] = useState<any>('created_at')

	const [exceptType1, setExceptType1] = useState(true)
	const [exceptType2, setExceptType2] = useState(true)
	const [exceptType3, setExceptType3] = useState(true)
	const [exceptType4, setExceptType4] = useState(true)
	const [exceptType5, setExceptType5] = useState(true)

	useEffect(() => {
		let exceptType = ''
		if (exceptType1) exceptType += `${exceptType ? ',' : ''}-2`
		if (exceptType2) exceptType += `${exceptType ? ',' : ''}-1`
		if (exceptType3) exceptType += `${exceptType ? ',' : ''}-9`
		if (exceptType4) exceptType += `${exceptType ? ',' : ''}6`
		if (exceptType5) exceptType += `${exceptType ? ',' : ''}7`
		setExceptType(exceptType)
	}, [exceptType1, exceptType2, exceptType3, exceptType4, exceptType5])

	useEffect(() => {
		if (title != '전체회원') {
			setExceptType1(false)
			setExceptType2(false)
			setExceptType3(false)
			setExceptType4(false)
			setExceptType5(false)
			setExceptType('')
		}
	}, [title])

	const [userId, setUserId] = useState('')
	const [isAll, setIsAll] = useState(false)

	useEffect(() => {
		setOrderType(orderType)
	}, [orderType])
	useEffect(() => {
		orderSort(order)
	}, [order])

	return (
		<>
			{title && <AdminSubTitle title={title} CustomComp={CustomComp} />}

			{search && (
				<AdminTableHeaderSection>
					<Space direction="horizontal">
						<AdminSearch
							searchWords={searchWords}
							options={[
								{ value: 'id', label: '회원코드' },
								{ value: 'level', label: '회원등급' },
								{ value: 'loginid', label: '로그인아이디' },
								{ value: 'fullname', label: '실명' },
								{ value: 'nickname', label: '닉네임' },
								{ value: 'email', label: '이메일' },
								{ value: 'phone', label: '휴대폰' },
								{ value: 'referral_code', label: '추천인코드' },
								{ value: 'country_code', label: '국가' },
							]}
							defaultKey={searchType ? searchType : 'fullname'}
							defaultKeyValue={'실명'}
							defaultValue={searchWord ? searchWord : ''}
						/>{' '}
						<Space.Compact
							style={{
								alignItems: 'center',
								fontSize: 12,
								whiteSpace: 'nowrap',
							}}>
							글로벌계좌보유
							<Switch
								checked={haswallet}
								onChange={e => {
									setHaswallet(e)
								}}
							/>
						</Space.Compact>
						<Space
							style={{
								alignItems: 'center',
								fontSize: 12,
								whiteSpace: 'nowrap',
							}}>
							그룹조회
							<Select
								defaultValue={'*'}
								onChange={e => {
									setGroup(e)
								}}
								value={group}
								style={{ width: '100%', minWidth: 150 }}
								options={[
									{ value: '*', label: '전체' },
									...(type1 || []),
								]}
							/>
						</Space>
						<Space style={{ alignItems: 'center' }}>
							정렬
							<Select
								defaultValue={'id'}
								onChange={e => {
									setOrderType1(e)
								}}
								value={orderType}
								style={{
									width: '100%',
									minWidth: 150,
									fontSize: 11,
								}}
								options={[
									{ value: 'id', label: '아이디' },
									{ value: 'created_at', label: '가입일' },
									{
										value: 'lastlogin_at',
										label: '최근로그인',
									},
								]}
							/>
							<Select
								defaultValue={'DESC'}
								onChange={e => {
									setOrder(e)
								}}
								value={order}
								style={{
									width: '100%',
									minWidth: 150,
									fontSize: 11,
								}}
								options={[
									{ value: 'DESC', label: '오름차순' },
									{ value: 'ASC', label: '내림차순' },
								]}
							/>
						</Space>
					</Space>

					{type == 'user' && (
						<View style={{ flexDirection: 'row' }}>
							<Addbutton
								onClick={() => setShowModal(!showModal)}
								title={'추가'}
							/>
							<AdminCModal
								show={showModal}
								setShow={setShowModal}>
								<AdminUserCreate
									closeModal={() => {
										setShowModal(false)
									}}
								/>
							</AdminCModal>
						</View>
					)}
				</AdminTableHeaderSection>
			)}

			{title == '전체회원' && (
				<Space size="small">
					제외
					<Space
						size={'small'}
						style={{
							border: '1px solid #ccc',
							padding: 5,
							borderRadius: 5,
						}}>
						<Space.Compact
							size="small"
							style={{
								alignItems: 'center',
								whiteSpace: 'nowrap',
								fontSize: 10,
							}}>
							거절
							<Switch
								onChange={e => setExceptType1(e)}
								defaultChecked={exceptType1}
							/>
						</Space.Compact>
						<Space.Compact
							size="small"
							style={{
								alignItems: 'center',
								whiteSpace: 'nowrap',
								fontSize: 10,
							}}>
							대기
							<Switch
								onChange={e => setExceptType2(e)}
								defaultChecked={exceptType2}
							/>
						</Space.Compact>
						<Space.Compact
							size="small"
							style={{
								alignItems: 'center',
								whiteSpace: 'nowrap',
								fontSize: 10,
							}}>
							블랙
							<Switch
								onChange={e => setExceptType3(e)}
								defaultChecked={exceptType3}
							/>
						</Space.Compact>
						<Space.Compact
							size="small"
							style={{
								alignItems: 'center',
								whiteSpace: 'nowrap',
								fontSize: 10,
							}}>
							모의
							<Switch
								onChange={e => setExceptType4(e)}
								defaultChecked={exceptType4}
							/>
						</Space.Compact>

						<Space.Compact
							size="small"
							style={{
								alignItems: 'center',
								whiteSpace: 'nowrap',
								fontSize: 10,
							}}>
							페이크
							<Switch
								onChange={e => setExceptType5(e)}
								defaultChecked={exceptType5}
							/>
						</Space.Compact>
					</Space>
				</Space>
			)}
		</>
	)
}

export default React.memo(AdminTableHeader)
